import * as Yup from 'yup';
import React from 'react';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// helpers/constants
import * as G from '../../../helpers';
// forms
import { Fieldset2 } from '../../../forms';
// feature new-import
import { importCLOFromFileFields } from '../settings';
//////////////////////////////////////////////////

const enhance = compose(
  withFormik({
    mapPropsToValues: () => ({ file: null, mapper: null }),
    handleSubmit: (values, { props }) => props.submitAction(values),
    validationSchema: Yup.object().shape({
      file: Yup.string().nullable(true).required(G.getRequiredLocaleTxt()),
      mapper: Yup.string().nullable(true).required(G.getRequiredLocaleTxt()),
    }),
  }),
  pure,
);

const CLOMapAndImport = enhance((props) => (
  <form onSubmit={props.handleSubmit}>
    <Fieldset2
      {...G.getFormikProps(props)}
      fields={importCLOFromFileFields}
      mapperOptions={props.mapperOptions}
      fieldsWrapperStyles={{ pt: 10, flexDirection: 'column' }}
    />
    <FormFooter />
  </form>
));

export default CLOMapAndImport;
